<script>
  import Button from '@components/buttons/button.svelte'
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import { KeyRound } from 'lucide-svelte'
  import { useForm } from '@inertiajs/svelte'

  let { open = $bindable(false), showButton = true } = $props()

  const form = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.clearErrors()
    if ($form.password !== $form.password_confirmation) {
      $form.setError('password_confirmation', 'Passwords do not match.')
      return
    }
    $form.patch('/settings/password', {
      onSuccess: () => {
        open = false
        $form.reset()
      },
    })
  }

  function handleClose() {
    $form.reset()
    $form.clearErrors()
  }
</script>

{#if showButton}
  <Button variant="secondary" text="Change password" Icon={KeyRound} onclick={() => open = true} class="mt-4" />
{/if}

<Modal bind:open title="Change password" width="32rem" onClose={handleClose}>

  <Form.Element {form} id="change-password-form" onsubmit={handleSubmit}>
    <Form.Items>
      <Form.Item name="current_password" label="Current password" type="password" bind:value={$form.current_password} required />
      <Form.Item name="password" label="New password" type="password" bind:value={$form.password} required />
      <Form.Item name="password_confirmation" label="Confirm new password" type="password" bind:value={$form.password_confirmation} required />
    </Form.Items>
  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="change-password-form" variant="submit" loading={$form.processing} text="Change password" Icon={KeyRound} />
  {/snippet}

</Modal>
